import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles?: string[];
}

export default function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
    const { currentUser, rsyncUser, dbUser, loading } = useAuth();
    const isAuthenticated = !!(currentUser || rsyncUser);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-neutral-950">
                <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (!dbUser) {
        return <Navigate to="/onboarding" replace />;
    }

    // Role-based access control
    if (allowedRoles && allowedRoles.length > 0) {
        const userRoles = dbUser.roles || [dbUser.role] || []; // Fallback for backward compatibility
        const hasAccess = allowedRoles.some(role => userRoles.includes(role));

        if (!hasAccess) {
            // Redirect to appropriate dashboard based on roles
            if (userRoles.includes('recruiter')) {
                return <Navigate to="/dashboard" replace />;
            } else if (userRoles.includes('candidate')) {
                return <Navigate to="/candidate/dashboard" replace />;
            }
            return <Navigate to="/" replace />;
        }
    }

    return <>{children}</>;
}
